/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import ProfileMenu from 'components/features/ProfileMenu';
import { PreferredLanguageQuickList } from 'components/features/LanguageDropdownList';

import sessionSelectors from 'redux/reduxStore/session';

function mapStateToProps(state) {
  const isLoggedIn = sessionSelectors.isLoggedIn(state);
  const requiresMfa = sessionSelectors.requiresMfa();

  return {
    isAuthenticated: isLoggedIn && !requiresMfa,
  };
};

const MenuSwitcher = ({ isAuthenticated }) => (
  isAuthenticated ? <ProfileMenu /> : <PreferredLanguageQuickList htmlId="preferredLanguage" />
)

export default connect(mapStateToProps)(MenuSwitcher);
